import { debugLogRef } from "@/utils/debugLog";

const state = {
  broadcastChannel: null,
};

const getters = {
  isBroadcastChannelReady: (state) => {
    return state.broadcastChannel !== null;
  },
};

const mutations = {
  SET_BROADCAST_CHANNEL(state, channel) {
    state.broadcastChannel = channel;
  },
};

const actions = {
  setupBroadcastChannel({ commit, dispatch }) {
    debugLogRef("SESSION UNIQUE", "setupBroadcastChannel: Initialisation");

    // Check if BroadcastChannel API is supported
    if (!window.BroadcastChannel) {
      console.warn("BroadcastChannel API not supported");
      return;
    }

    // Early return si le channel existe déjà
    if (state.broadcastChannel) {
      debugLogRef(
        "SESSION UNIQUE",
        "setupBroadcastChannel: Channel déjà existant, setup ignoré",
      );
      return;
    }

    // Create the channel
    const channel = new BroadcastChannel("iizenglish-session");
    debugLogRef(
      "SESSION UNIQUE",
      "setupBroadcastChannel: Channel créé (iizenglish-session)",
    );

    // Listener for messages
    channel.onmessage = (event) => {
      debugLogRef(
        "SESSION UNIQUE",
        "setupBroadcastChannel: Message reçu",
        event.data,
      );
      if (event.data.type === "NEW_SESSION_OPENED") {
        debugLogRef(
          "SESSION UNIQUE",
          "setupBroadcastChannel: NEW_SESSION_OPENED détecté",
        );
        dispatch("handleNewTabOpened");
      }
    };

    commit("SET_BROADCAST_CHANNEL", channel);
  },

  announceNewSession({ state }) {
    debugLogRef(
      "SESSION UNIQUE",
      "announceNewSession: Annonce nouvelle session",
    );

    if (state.broadcastChannel) {
      const message = {
        type: "NEW_SESSION_OPENED",
        timestamp: Date.now(),
      };
      debugLogRef(
        "SESSION UNIQUE",
        "announceNewSession: Envoi message broadcast",
        message,
      );
      state.broadcastChannel.postMessage(message);
    } else {
      debugLogRef(
        "SESSION UNIQUE",
        "announceNewSession: Pas de channel, message non envoyé",
      );
    }
  },

  handleNewTabOpened({ commit, dispatch }) {
    debugLogRef(
      "SESSION UNIQUE",
      "handleNewTabOpened: Un autre onglet s'est ouvert, blocage de cette session",
    );

    dispatch(
      "sessions/handleInvalidSession",
      { source: "broadcast" },
      { root: true },
    );

    debugLogRef(
      "SESSION UNIQUE",
      "handleNewTabOpened: SET_SESSION_BLOCKED = true",
    );
    commit("sessions/SET_SESSION_BLOCKED", true, { root: true });

    debugLogRef("SESSION UNIQUE", "handleNewTabOpened: Arrêt heartbeat");
    dispatch("sessions/stopHeartbeat", null, { root: true });
  },

  closeBroadcastChannel({ state, commit }) {
    debugLogRef(
      "SESSION UNIQUE",
      "closeBroadcastChannel: Fermeture du channel",
    );

    if (state.broadcastChannel) {
      state.broadcastChannel.close();
      commit("SET_BROADCAST_CHANNEL", null);
      debugLogRef("SESSION UNIQUE", "closeBroadcastChannel: Channel fermé");
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
